const m = window.require("discourse/lib/ajax");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;